import { createViewVNode } from 'sky-engine/views/ViewManager'

export default {
  name: 'SkyDialogFormAdapter',
  components: {
    formController: () => import('sky-engine/views/formController/index.js')
  },
  props: {
    metaData: {
      type: Object,
      default() {
        return {}
      }
    },
    cbOk: {
      type: Function,
      default() {
        return () => {}
      }
    }
  },
  data() {
    return {
      view: this.metaData
    }
  },
  render(h) {
    const view = this.view
    view.ref = 'formRef'
    return <div>{createViewVNode(view, h)}</div>
  },
  methods: {
    handleOk() {
      return this.$refs.formRef.ok().then(() => {
        this.cbOk()
      })
    },
    handelClose() {
      return this.$refs.formRef.cancel()
    }
  }
}
